module.exports = __webpack_public_path__ + "img/rg_cnh.ae659af7.png";